import { render, staticRenderFns } from "./DetailsLogs.vue?vue&type=template&id=20cbe3f0"
import script from "./DetailsLogs.vue?vue&type=script&lang=js"
export * from "./DetailsLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports